// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._L5birDwz90GngvOJ0Jk {
  text-align: left;
  padding: 6px 10px;
  box-sizing: border-box;
  background: #f4f4f4;
  display: block !important;
  overflow: visible !important;
}

.zCuUaJBi7nVTdBIPvKET {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65) !important;
  text-transform: uppercase;
}

.u2ab0xB1dIb0iM1c_SNN {
  display: flex;
  align-items: center;
  margin-top: 2px;
}

.apsgCItRAMbRswfFLskY {
  display: flex;
}

.ewIWv6b7oXUU3Fk8jtvt {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4) !important;
  font-style: italic;
  margin-left: 4px;
}

.bezxoUvt_qFZxhluu36z {
  flex: 1;
}

.eMd65CYb1LL7hhil2NS4 {
  display: flex;
  color: rgba(0, 0, 0, 0.2) !important;
}

.bufgTS5y9fWpOSBGCWku {
  max-width: 275px;
  white-space: normal !important;
  height: auto !important;
  line-height: 16px !important;
  padding: 8px !important;
}

.UdqDBOEZRhSSLPFo8Uzx {
  cursor: col-resize;
  position: absolute;
  top: 0;
  right: -2px;
  bottom: 0;
  width: 4px;
  /*background: #369;*/
  background: transparent;
  z-index: 999;
}

.UdqDBOEZRhSSLPFo8Uzx:hover,
.UdqDBOEZRhSSLPFo8Uzx.Vaq64Hl5zfwRTGW2Q7Po {
  background: #369;
}

.Jw5PIS2nb4BHAQGzVyJE {
  margin-right: 2px;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./datasets/handsontable/read-grid/cell-renderers/ReadGridHeader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":[".columnHeader {\n  text-align: left;\n  padding: 6px 10px;\n  box-sizing: border-box;\n  background: #f4f4f4;\n  display: block !important;\n  overflow: visible !important;\n}\n\n.row1 {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.65) !important;\n  text-transform: uppercase;\n}\n\n.row2 {\n  display: flex;\n  align-items: center;\n  margin-top: 2px;\n}\n\n.iconContainer {\n  display: flex;\n}\n\n.iconText {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.4) !important;\n  font-style: italic;\n  margin-left: 4px;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.extraContainer {\n  display: flex;\n  color: rgba(0, 0, 0, 0.2) !important;\n}\n\n.tooltip {\n  max-width: 275px;\n  white-space: normal !important;\n  height: auto !important;\n  line-height: 16px !important;\n  padding: 8px !important;\n}\n\n.dragHandle {\n  cursor: col-resize;\n  position: absolute;\n  top: 0;\n  right: -2px;\n  bottom: 0;\n  width: 4px;\n  /*background: #369;*/\n  background: transparent;\n  z-index: 999;\n}\n\n.dragHandle:hover,\n.dragHandle.active {\n  background: #369;\n}\n\n.required {\n  margin-right: 2px;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"columnHeader": `_L5birDwz90GngvOJ0Jk`,
	"row1": `zCuUaJBi7nVTdBIPvKET`,
	"row2": `u2ab0xB1dIb0iM1c_SNN`,
	"iconContainer": `apsgCItRAMbRswfFLskY`,
	"iconText": `ewIWv6b7oXUU3Fk8jtvt`,
	"spacer": `bezxoUvt_qFZxhluu36z`,
	"extraContainer": `eMd65CYb1LL7hhil2NS4`,
	"tooltip": `bufgTS5y9fWpOSBGCWku`,
	"dragHandle": `UdqDBOEZRhSSLPFo8Uzx`,
	"active": `Vaq64Hl5zfwRTGW2Q7Po`,
	"required": `Jw5PIS2nb4BHAQGzVyJE`
};
export default ___CSS_LOADER_EXPORT___;
